import {Typography, useReachGoalCallback} from '@yandex-delivery/blocks'
import type {PropsWithClasses} from '@yandex-delivery/blocks/theme/UNSTABLE_makeStyles'
import React, {useCallback, useEffect} from 'react'
import {config} from 'src/shared/config'
import {Brand} from 'src/shared/types'

import {Drawer, DrawerSection} from '../../drawer'
import type {Props as BaseProps} from '../types'
import {type ClassKey, useClasses} from './Postcard.classes'
import YandexEnLogo from './YandexEnLogo'
import YandexPromoButton from './YandexPromoButton'
import YandexRuLogo from './YandexRuLogo'
import YangoLogo from './YangoLogo'
import YangoPromoButton from './YangoPromoButton'

type Props = PropsWithClasses<ClassKey> & BaseProps

const Postcard = React.forwardRef<HTMLDivElement, Props>(({data, classes: classesProp}, ref) => {
  const classes = useClasses(classesProp)
  const reachGoal = useReachGoalCallback()
  const clickHandler = useCallback(() => reachGoal('TeaserInstallButtonClicked'), [reachGoal])
  const AppLogo = config.brand === Brand.Yango ? YangoLogo : config.lang === 'ru' ? YandexRuLogo : YandexEnLogo
  const PromoButtonComponent = config.brand === Brand.Yandex ? YandexPromoButton : YangoPromoButton

  useEffect(() => {
    reachGoal('TeaserShown')

    return () => reachGoal('TeaserClosed')
  }, [reachGoal])

  return (
    <Drawer className={classes.root} ref={ref}>
      <DrawerSection fullHeight>
        <div className={classes.postcard} style={{backgroundImage: `url(${data.content.url})`}}>
          <div className={classes.postcardFooter}>
            <AppLogo color="white" />
            <Typography className={classes.summary} group="tight" thickness="medium" variant="body2">
              {data.summary_postcard}
            </Typography>
          </div>
        </div>
        <div className={classes.buttonRoot}>
          <PromoButtonComponent onClick={clickHandler} />
        </div>
      </DrawerSection>
    </Drawer>
  )
})

export default Postcard
